export default "__VITE_ASSET__d14c4385__"